module.exports = __webpack_public_path__ + "static/6.Risk Disclosure Statement for Options Trading-971daf79e4533e28d2cb53c8324318d2.pdf";